export default __webpack_public_path__ + "static/using-gray_desktop-5e7e5f56eb0d1943cd66190116d5b38d.jpg";